/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */

export type UserMemberFilter = typeof UserMemberFilter[keyof typeof UserMemberFilter];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserMemberFilter = {
  All: 'All',
  UserIsMember: 'UserIsMember',
  UserNotIsMember: 'UserNotIsMember',
} as const;
